import { on, fire } from "delegated-events";

const filterList = () => {
  const searchValue = document.querySelector('#program-search').value.toLowerCase()
  const listItems = document.querySelectorAll('.program-list-data-overlay li')
  const jsondata = JSON.parse(document.querySelector(".program-search-data").textContent)
  const form = document.querySelector('.component-program-search-overlay form')

  form.addEventListener('submit', (e) => {
    e.preventDefault()
  })

  const matchingProgramIds = jsondata
      .filter(program =>
          program.title.toLowerCase().includes(searchValue) ||
          (program.keywords && program.keywords.toLowerCase().includes(searchValue))
      )
      .map(program => program.id)

  listItems.forEach(item => {
      const programId = +item.getAttribute('data-program-id')
      if (searchValue === '' || matchingProgramIds.includes(programId)) {
          item.style.display = 'block'
      } else {
          item.style.display = 'none'
      }
  });
}
on('modal:populate', 'html', (e) => {
  e.detail.modalEl.querySelectorAll(".component-program-search-overlay").forEach((el) => {
    el.querySelector('#program-search').addEventListener('input', filterList);
  });
})
